const getters = {
  state: (state) => state,
  hasLogin: (state) => state.user.hasLogin,
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  name: (state) => state.user.userInfo.name ?? '匿名用户',
  userName: (state) => state.user.userName,
  avatar: (state) => state.user.userInfo.avatar ?? '',
  sidebarRouters: (state) => state.routes.sidebarRouters,
  tagView: (state) => state.routes.tagView,
  currencySymbol: (state) => { // 货币符号
    const currency = (state.user.userInfo && state.user.userInfo.currency) || 'USD' // 默认 'USD'
    return { 'USD': '$', 'CNY': '￥' }[currency]
  },
  theme: (state) => {
    const theme = { ...state.settings.theme }
    if (state.user.userInfo.isVip) {
      theme.head = 1
    } else {
      theme.head = 0
    }
    return theme
  }
}
export default getters
